import { useState } from "react";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import styles from "./ViewConsent.module.css";
import { getViewDocumentHistory } from "../../../../Services/BuySell/Listing";
import { useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useEffect } from "react";
import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";
import { usePdfPreview } from "../../../../hooks/usePdfPreview";
import { formatDate } from "../../../../helpers/dateFormat";
import { is } from "react-date-range/dist/locale";

const ViewConsent = ({
  open,
  onClose,
  connectionId,
  mode,
  isAdmin,
  useSecondaryAccent = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [doc, setDoc] = useState(null);
  const [ldc, setLdc] = useState(null);
  const companyName = useSelector(
    (state) => state.persistedReducer.company?.displayName
  );
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  const handleViewDoc = async (id) => {
    try {
      const response = await getDocumentUrlByLedgerId(id);
      const url = response.data;
      if (url) window.open(url, "_blank", "noopener");
      else alert("Document URL not found");
    } catch {
      alert("Could not fetch document URL.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const { data } = await getViewDocumentHistory(connectionId);
      // Filter for CONSENT docs uploaded by this company
      const filtered = data
        ?.filter(
          (d) =>
            d.documentType === "CONSENT" &&
            (d.companyName === companyName || isAdmin)
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setDoc(filtered?.[0] || null);
      const filteredLdc = data
        ?.filter((d) => d.documentType === "LDC")
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setLdc(filteredLdc?.[0] || null);
      setLoading(false);
    };
    if (open && connectionId) fetchData();
  }, [open, connectionId, companyName, isAdmin]);

  return (
    <>
      <PdfPreviewModal />
      <Modal open={open} onClose={onClose}>
        <div
          className={`${styles.modal} ${
            useSecondaryAccent ? "secondaryAccent" : ""
          }`}
        >
          <div className={styles.header}>
            <span className={styles.title}>View Consent / LDC</span>
            <button className={styles.close} onClick={onClose}>
              <Close fontSize="medium" />
            </button>
          </div>
          <div className={styles.tableWrapper}>
            {loading ? (
              <p>Loading...</p>
            ) : doc || ldc ? (
              <>
                {doc && (
                  <div className={styles.documentPreview}>
                    <div>
                      <div style={{ fontSize: "12px", marginBottom: "4px" }}>
                        {String(doc.documentType)}
                      </div>
                      <div
                        style={{ wordWrap: "break-word", maxWidth: "300px" }}
                      >
                        {doc.filename}
                      </div>
                    </div>
                    <div className={styles.actions}>
                      {" "}
                      <p>{formatDate(doc.createdAt)}</p>
                      <button
                        className={styles.eyeIcon}
                        onClick={() =>
                          handlePreviewGeneralTerms(doc.id, {
                            title: `${doc.filename}`,
                          })
                        }
                      >
                        <VisibilityIcon style={{ color: "var(--primary-color-text)" }} />
                      </button>
                    </div>
                  </div>
                )}

                {ldc && (
                  <div className={styles.documentPreview}>
                    <div>
                      <div style={{ fontSize: "12px", marginBottom: "4px" }}>
                        {String(ldc.documentType)}
                      </div>
                      <div
                        style={{ wordWrap: "break-word", maxWidth: "300px" }}
                      >
                        {ldc.filename}
                      </div>
                    </div>
                    <div className={styles.actions}>
                      {" "}
                      <p>{formatDate(ldc.createdAt)}</p>
                      <button
                        className={styles.eyeIcon}
                        onClick={() =>
                          handlePreviewGeneralTerms(ldc.id, {
                            title: `${ldc.filename}`,
                          })
                        }
                      >
                        <VisibilityIcon style={{ color: "var(--primary-color-text)" }} />
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <p>No document found</p>
            )}
          </div>
          {mode !== "view" && (
            <div className={styles.footer}>
              <button onClick={onClose} className={styles.reject}>
                Close
              </button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ViewConsent;
